import styled from '@emotion/styled';
import { Link as UILink } from 'react-router-dom';

export const SContainer = styled.section``;

export const SCard = styled.div`
  background-color: white;
  margin-top: 16px;
`;

export const STitle = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
  margin-left: 16px;
`;

export const SLink = styled(UILink)`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: rgba(0, 0, 0, 0.85);
  margin-left: 16px;
  text-decoration: underline;
  &:hover {
    color: rgba(0, 0, 0, 0.85);
  }
`;
